import axios from 'axios';
import TokenService from './token.service';
import { fetchUser } from 'store/UserSession/features';
import { store } from 'store';
import { axiosAiTokenValidationAPI } from './endpoints';
// const BASE_URL = 'http://localhost:8080/api';

const axiosAIKeys = axios.create({
    baseURL: axiosAiTokenValidationAPI,
    headers: { 'Content-Type': 'application/json' },
});

axiosAIKeys.interceptors.request.use(
    (config) => {
        const token = TokenService.getLocalAccessToken();
        if (token) {
            config.headers['authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosAIKeys.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalReq = error?.config;
        if (error.response && error.response.status === 403) {
            TokenService.removeUser();
            store.dispatch(fetchUser(null));
            originalReq._retry = true;
        }
        return Promise.reject(error);
    }
);

const PROVIDER_MAP = {
    openai: 'OPENAI',
    claude: 'CLAUDE',
    gemini: 'GEMINI',
    perplexity: 'PERPLEXITY',
};

export const getAIKeys = () =>
    axiosAIKeys.get('/ai/keys').then((res) => res.data);


export const deleteAIKey = (provider) =>
    axiosAIKeys
        .delete(`/ai/keys/${PROVIDER_MAP[provider]}`)
        .then((res) => res.data);

export const validateToken = (provider, apiKey, model) =>
    axiosAIKeys
        .post('/ai/validate-token', {
            provider: PROVIDER_MAP[provider],
            apiKey,
            model,
        })
        .then((res) => res.data);

export default axiosAIKeys;